// Open indeed in a new tab
document.addEventListener("DOMContentLoaded", function() {
  const links = document.querySelectorAll("a");
  links.forEach(link => {
    link.addEventListener("click", function(event) {
      const href = this.getAttribute("href");
      if (href && href.includes("www.indeed.com")) {
        event.preventDefault(); // Prevent the default behavior
        window.open(href, '_blank'); // Open the link in a new tab
      }
    });
  });
});







